import React, { Suspense, useEffect, useRef } from "react";
// routing
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
// redux
import { useDispatch, useSelector } from "react-redux";
// types
import { SET_ADMIN } from "./store/admin/types";
import { ensureAgencyToken } from "./util/agencySession";

// pages
import Admin from "./pages/Admin";
import TotalIncome from "./pages/TotalIncome";
import Creators from "./pages/Creators";
import HostHistory from "./pages/HostHistory";
import LanguageSwitcher from "./languageSwitcher/LanguageSwitcher";
import i18n from "./i18n";

// layout
import AgencyLayout from "./layouts/AgencyLayout";

const SUPPORTED_LANGS = [
  "en", "ar", "bn", "zh", "fr", "de", "hi", "it", "id", "ko",
  "pt", "ru", "es", "sw", "tr", "te", "ta", "ur",
];

function App() {
  const dispatch = useDispatch();
  const { isAuth } = useSelector((state) => state.admin);
  const navigate = useNavigate();
  const location = useLocation();
  const bootstrapped = useRef(false);

  // When Open in Server / in-app WebView
  useEffect(() => {
    if (bootstrapped.current) return;
    bootstrapped.current = true;

    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    const language = queryParams.get("language");

    if (language && SUPPORTED_LANGS.includes(language.toLowerCase())) {
      const normalizedLang = language.toLowerCase();
      localStorage.setItem("language", normalizedLang);
      i18n.changeLanguage(normalizedLang);
    }

    const agencyId = id || localStorage.getItem("agencyId");
    if (id) {
      localStorage.setItem("agencyId", id);
    }

    (async () => {
      if (agencyId) {
        try {
          const token = await ensureAgencyToken(agencyId, { force: true });
          if (token) {
            dispatch({ type: SET_ADMIN, payload: token });
          }
        } catch (e) {
          console.log("agency bootstrap session failed", e?.message || e);
        }
        navigate("/agencypanel/homePage", { replace: true });
      }
    })();
  }, [dispatch, location.search, navigate]);

  // Re-hydrate axios Authorization if TOKEN already in storage (page refresh)
  useEffect(() => {
    const token = localStorage.getItem("TOKEN");
    if (token && !isAuth) {
      dispatch({ type: SET_ADMIN, payload: token });
    }
  }, [dispatch, isAuth]);

  return (
    <div className="App">
      <LanguageSwitcher/>
      <Suspense fallback={""}>
        <Routes>
          <Route path="/agencypanel" element={<AgencyLayout />}>
            <Route path="homePage" element={<Admin />} />
            <Route path="Income" element={<TotalIncome />} />
            <Route path="creators" element={<Creators />} />
            <Route path="hosthistory" element={<HostHistory />} />
            <Route path="agencyredeem" element={<Navigate to="/agencypanel/homePage" replace />} />
            <Route path="agencyredeem/create" element={<Navigate to="/agencypanel/homePage" replace />} />
          </Route>

          <Route path="/" element={<Navigate to="/agencypanel/homePage" replace />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
